export type BusinessTrendData = {
  chart_data: BusinessTrendChartData[];
  kpi: KPIInfo;
};

export type BusinessTrendChartData = {
  date: string;
  business_cost: number;
  po_cost: number;
  sell_price: number;
  volume: number;
};

export type KPIInfo = {
  recommended_business_cost: number;
  table_data: BTrendTableData[];
};

export type BTrendTableData = {
  agent_pricing: number;
  vendor_quotes: number;
  target_cost: number;
  project_pricing: number;
  proxy_flag: number;
  bc_under_quote_flag: number;
};

export enum TimeFrame {
  MONTH = "monthly",
  WEEK = "weekly",
}
